<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  options: {
    type: Array,
    required: true
  },
  modelValue: {
    type: String,
    required: true
  },
  placeholder: {
    type: String,
    default: 'Select option'
  }
})

const emit = defineEmits(['update:modelValue'])

const isOpen = ref(false)
const searchQuery = ref('')
const dropdownRef = ref(null)

const filteredOptions = computed(() => {
  if (!searchQuery.value) return props.options
  return props.options.filter(option => 
    option.toLowerCase().includes(searchQuery.value.toLowerCase())
  )
})

const handleClickOutside = (event) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    isOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})

const selectOption = (option) => {
  emit('update:modelValue', option)
  isOpen.value = false
  searchQuery.value = ''
}
</script>

<template>
  <div class="relative" ref="dropdownRef">
    <button
      type="button"
      @click="isOpen = !isOpen"
      class="w-full flex items-center justify-between px-4 py-2 border border-gray-200 rounded-lg bg-white text-gray-700 hover:bg-gray-50 focus:outline-none"
    >
      <span class="text-gray-600">{{ modelValue === 'all' ? placeholder : modelValue }}</span>
      <i class="fas fa-chevron-down text-gray-400" :class="{ 'transform rotate-180': isOpen }"></i>
    </button>

    <div
      v-if="isOpen"
      class="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg"
    >
      <div class="p-2 border-b">
        <div class="relative">
          <input
            v-model="searchQuery"
            type="text"
            class="w-full px-4 py-2 pl-9 border border-gray-200 rounded-lg focus:outline-none"
            placeholder="Search..."
            @click.stop
          >
          <i class="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
        </div>
      </div>

      <div class="max-h-60 overflow-y-auto">
        <button
          type="button"
          class="w-full px-4 py-2 text-left hover:bg-gray-50 focus:outline-none text-gray-600"
          :class="{ 'bg-pink-50 text-pink-600': modelValue === 'all' }"
          @click="selectOption('all')"
        >
          All Clients
        </button>
        <button
          v-for="option in filteredOptions"
          :key="option"
          type="button"
          class="w-full px-4 py-2 text-left hover:bg-gray-50 focus:outline-none text-gray-600"
          :class="{ 'bg-pink-50 text-pink-600': modelValue === option }"
          @click="selectOption(option)"
        >
          {{ option }}
        </button>
      </div>
    </div>
  </div>
</template> 